import * as types from "./actionTypes";

const NOTICE_DURATION_MS = 4000;

let hideTimer = null;
let undoHandler = null; // what "Undo" on the current toast does (a thunk or a function)

/**
 * Shows a short message at the bottom of the screen; it disappears by itself. `kind` is
 * "error" (default) or "info"; `sub` is a second, quieter line; `undo` makes the toast offer
 * an Undo button that runs it (a plain function or a thunk to dispatch).
 */
export const showNotice = (message, kind = "error", { sub = null, undo = null } = {}) => (dispatch) => {
  clearTimeout(hideTimer);
  undoHandler = undo;
  dispatch({ type: types.NOTICE_SHOW, message, kind, sub, canUndo: Boolean(undo) });
  hideTimer = setTimeout(() => dispatch(clearNotice()), NOTICE_DURATION_MS);
};

/** A confirmation toast ("Added to Sunday morning"). */
export const showInfo = (message, options) => showNotice(message, "info", options);

export const clearNotice = () => {
  clearTimeout(hideTimer);
  undoHandler = null;
  return { type: types.NOTICE_CLEAR };
};

/** Runs the current toast's undo, then closes it. */
export const undoNotice = () => (dispatch) => {
  const undo = undoHandler;
  dispatch(clearNotice());
  if (typeof undo === "function") {
    const result = undo();
    if (typeof result === "function") dispatch(result);
  }
};
